import React from 'react';
import SEO from '../components/SEO';
import UnifiedHero from '../components/Hero/UnifiedHero';
import UnifiedServices from '../components/services/UnifiedServices';
import SocialValueSection from '../components/social-value/SocialValueSection';
import Technologies from '../components/Technologies';
import UnifiedCaseStudies from '../components/case-studies/UnifiedCaseStudies';
import ClientSuccess from '../components/success/ClientSuccess';

export default function Home() {
  return (
    <>
      <SEO
        title="AI Automation for Government & Enterprise | G-Cloud 14 | UK-Based"
        description="Delivering 15:1 ROI through intelligent AI automation. Trusted by UK government, NHS, councils, and leading enterprises. G-Cloud 14 approved. Cyber Essentials Plus certified."
        keywords={[
          'AI Automation',
          'G-Cloud 14',
          'Enterprise AI',
          'Government AI Automation',
          'NHS Automation',
          'RPA Solutions',
          'Document Processing',
          'UK Data Residency',
          'Cyber Essentials Plus',
          'Business Process Automation'
        ]}
      />
      <UnifiedHero />
      <UnifiedServices />
      <SocialValueSection />
      <Technologies />
      <ClientSuccess />
      <UnifiedCaseStudies />
    </>
  );
}